import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Page not found");
  return (
    <div className="mx-auto max-w-2xl px-5 py-32 text-center">
      <img src="/lion-logo.webp" alt="" className="mx-auto h-16 w-16 object-contain" />
      <h1 className="mt-6 font-display text-5xl text-navy font-semibold">Page not found</h1>
      <p className="mt-4 text-muted-foreground">The page you're looking for isn't here.</p>
      <Button asChild className="mt-8 rounded-full bg-emerald hover:bg-emerald-dark text-white px-8"><Link to="/">Return home</Link></Button>
    </div>
  );
}
